import {
  getModule,
  Module,
  Mutation,
  VuexModule,
} from "vuex-module-decorators";
import store from "@/store";
import { PrestadorResumidoModel } from '@/models/cadastros/saude/PrestadorResumidoModel';

export interface IConfiguracaoAgendaSaudeStore extends VuexModule {
  prestadorSelecionado: PrestadorResumidoModel | null;
}

const getDefaultState = () => {
  return {
    prestadorSelecionado: null,
  } as IConfiguracaoAgendaSaudeStore;
};

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "ConfiguracaoAgenda",
})
class ConfiguracaoAgendaSaudeStore extends VuexModule
  implements IConfiguracaoAgendaSaudeStore {
  prestadorSelecionado: PrestadorResumidoModel | null = null;

  @Mutation
  RESET() {
    Object.assign(this, getDefaultState());
  }

  @Mutation
  SET_PRESTADOR_SELECIONADO(payload: PrestadorResumidoModel) {
    this.prestadorSelecionado = payload;
  }


}

export const configuracaoAgendaSaudeStore = getModule(
  ConfiguracaoAgendaSaudeStore
);
